import styled from 'styled-components';

export const CartLineItemsWrapper = styled.div`
  flex: 1;
`;
